/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DevicePropertyVm,
    DevicePropertyVmFromJSON,
    DevicePropertyVmFromJSONTyped,
    DevicePropertyVmToJSON,
    SpecialPlaceVm,
    SpecialPlaceVmFromJSON,
    SpecialPlaceVmFromJSONTyped,
    SpecialPlaceVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface DynamicDeviceVm
 */
export interface DynamicDeviceVm {
    /**
     * 
     * @type {string}
     * @memberof DynamicDeviceVm
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DynamicDeviceVm
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DynamicDeviceVm
     */
    isActive?: boolean;
    /**
     * 
     * @type {Array<DevicePropertyVm>}
     * @memberof DynamicDeviceVm
     */
    deviceProperties?: Array<DevicePropertyVm> | null;
    /**
     * 
     * @type {SpecialPlaceVm}
     * @memberof DynamicDeviceVm
     */
    specialPlace?: SpecialPlaceVm;
    /**
     * 
     * @type {string}
     * @memberof DynamicDeviceVm
     */
    redirectPathPostfix1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DynamicDeviceVm
     */
    redirectPathPostfix2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DynamicDeviceVm
     */
    deviceExternalId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DynamicDeviceVm
     */
    createdBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DynamicDeviceVm
     */
    createdDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof DynamicDeviceVm
     */
    modifiedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DynamicDeviceVm
     */
    modifiedDate?: Date | null;
}

export function DynamicDeviceVmFromJSON(json: any): DynamicDeviceVm {
    return DynamicDeviceVmFromJSONTyped(json, false);
}

export function DynamicDeviceVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): DynamicDeviceVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
        'deviceProperties': !exists(json, 'deviceProperties') ? undefined : (json['deviceProperties'] === null ? null : (json['deviceProperties'] as Array<any>).map(DevicePropertyVmFromJSON)),
        'specialPlace': !exists(json, 'specialPlace') ? undefined : SpecialPlaceVmFromJSON(json['specialPlace']),
        'redirectPathPostfix1': !exists(json, 'redirectPathPostfix1') ? undefined : json['redirectPathPostfix1'],
        'redirectPathPostfix2': !exists(json, 'redirectPathPostfix2') ? undefined : json['redirectPathPostfix2'],
        'deviceExternalId': !exists(json, 'deviceExternalId') ? undefined : json['deviceExternalId'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : json['modifiedBy'],
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
    };
}

export function DynamicDeviceVmToJSON(value?: DynamicDeviceVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'isActive': value.isActive,
        'deviceProperties': value.deviceProperties === undefined ? undefined : (value.deviceProperties === null ? null : (value.deviceProperties as Array<any>).map(DevicePropertyVmToJSON)),
        'specialPlace': SpecialPlaceVmToJSON(value.specialPlace),
        'redirectPathPostfix1': value.redirectPathPostfix1,
        'redirectPathPostfix2': value.redirectPathPostfix2,
        'deviceExternalId': value.deviceExternalId,
        'createdBy': value.createdBy,
        'createdDate': value.createdDate === undefined ? undefined : (value.createdDate.toISOString()),
        'modifiedBy': value.modifiedBy,
        'modifiedDate': value.modifiedDate === undefined ? undefined : (value.modifiedDate === null ? null : value.modifiedDate.toISOString()),
    };
}


